import { create } from 'zustand';

import { AnyBlock } from '../../types';

type DeleteMediaKitStore = {
  isModalOpen: boolean;
  mediaKitId: string | null;

  openModalToDeleteMK: (id: DeleteMediaKitStore['mediaKitId']) => void;
  reset: () => void;
};

type DeleteBlockStore = {
  isModalOpen: boolean;
  block: AnyBlock | null;

  openModalToDeleteBlock: (id: DeleteBlockStore['block']) => void;
  reset: () => void;
};

export const useDeleteMediaKitStore = create<DeleteMediaKitStore>((set) => ({
  isModalOpen: false,
  mediaKitId: null,
  openModalToDeleteMK: (id) => set({ isModalOpen: true, mediaKitId: id }),
  reset: () => set({ isModalOpen: false, mediaKitId: null }),
}));

export const useDeleteBlockStore = create<DeleteBlockStore>((set) => ({
  isModalOpen: false,
  block: null,
  openModalToDeleteBlock: (block) => set({ isModalOpen: true, block: block }),
  reset: () => set({ isModalOpen: false, block: null }),
}));
